var map = {
	"./regCode-0.png": "PgPB",
	"./regCode-1.png": "sfVT",
	"./regCode-2.png": "31rC",
	"./regCode-3.png": "xRfx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7yka";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home ^\.\/regCode\-.*\.png$
// module id = 7yka
// module chunks = 1